import Vue from "vue";

import Avatar from "./packages/avatar";

import "./style/index.scss";

Vue.use(Avatar);
